// // theme.js (MUI v4)
// import { createTheme } from "@material-ui/core/styles";

// const theme = createTheme({
//   palette: {
//     type: "light", // Light mode
//     primary: {
//       main: "#000000",
//       light: "#333333",
//       contrastText: "#ffffff",
//     },
//     secondary: {
//       main: "#f57c00",        // ✅ New secondary (orange)
//       light: "#ffad42",       // lighter orange
//       dark: "#bb4d00",        // darker orange
//       contrastText: "#ffffff"
//     },
//     background: {
//       default: "#f9f9f9",
//       paper: "#ffffff",
//     },
//     grey: {
//       100: "#f5f5f5",
//       200: "#eeeeee",
//       300: "#e0e0e0",
//       400: "#bdbdbd",
//       500: "#9e9e9e",
//       600: "#757575",
//       700: "#616161",
//       800: "#424242",
//       900: "#212121",
//     },
//     frontWeight: {
//       frontWeight100: 100,
//       frontWeight200: 200,
//       frontWeight300: 300,
//       frontWeight400: 400,
//       frontWeight500: 500,
//       frontWeight600: 600,
//       frontWeight700: 700,
//       frontWeight800: 800,
//       frontWeight900: 900,
//     },
//   },
//   chart: {
//     primary: "#000000",          // use primary.main
//     secondary: "#f57c00",       // use secondary.main
//     success: "#4caf50",
//     info: "#2196f3",
//     warning: "#ff9800",
//     error: "#f44336",
//     lightGrey: "#e0e0e0",
//     darkGrey: "#616161",
//     palette: [
//       "#000000",
//       "#f57c00",
//       "#4caf50",
//       "#2196f3",
//       "#ff9800",
//       "#f44336",
//       "#616161",
//       "#9e9e9e",
//     ],
//   },
//   shape: {
//     borderRadius: 16,
//   },
//   spacing: 8,
//   typography: {
//     fontFamily: 'Aptos',
//     fontSize: 14,
//     h5: {
//       fontWeight: 600,
//       fontSize: "1.5rem",
//     },
//     h6: {
//       fontWeight: 500,
//       fontSize: "1.1rem",
//     },
//     body2: {
//       color: "#666",
//       fontSize: "0.85rem",
//       fontWeight: 500,
//       marginBottom: "4px",
//     },
//     button: {
//       textTransform: "none",
//       fontWeight: 600,
//     },
//   },
//   overrides: {
//     MuiPaper: {
//       root: {
//         boxShadow: "0 4px 20px 0 rgba(0,0,0,0.05)",
//       },
//     },
//     MuiGrid: {
//       container: {
//         width: "100% !important",
//         margin: "0 !important",
//       },
//     },
//     MuiInputBase: {
//       root: {
//         backgroundColor: "#ffffff",
//         transition: "all 0.3s ease",
//         "&$disabled": {
//           backgroundColor: "#f0f0f0",
//         },
//       },
//     },
//     MuiOutlinedInput: {
//       root: {
//         borderRadius: 6,
//         "&:hover fieldset": {
//           borderColor: "#999",
//         },
//         "&.Mui-focused fieldset": {
//           borderColor: "#000", // focus black
//           boxShadow: "0 0 0 2px rgba(0,0,0,0.08)",
//         },
//         '&.Mui-error fieldset': {
//           borderColor: "red",
//           boxShadow: '0 0 0 0.2rem rgba(244,67,54,0.25)',
//         },
//       },
//       input: {
//         padding: "12px",
//         fontSize: 16,
//         color: "#333",
//       },
//       notchedOutline: {
//         borderColor: "#ccc",
//       },
//     },
//     MuiFormLabel: {
//       root: {
//         fontSize: 16,
//         fontWeight: 500,
//         color: "#444",
//         "&$focused": {
//           color: "#000",
//         },
//       },
//       focused: {},
//     },
//     MuiInputLabel: {
//       outlined: {
//         fontSize: 16,
//         fontWeight: 500,
//         transform: "translate(14px, 14px) scale(1)",
//         '&.Mui-error': {
//           color: "red",
//         },
//       },
//     },
//     MuiFormHelperText: {
//       root: {
//         fontSize: 12,
//         marginLeft: "0px !important",
//         marginRight: "0px !important",
//         '&.Mui-error': {
//           color: "red",
//         },
//       },
//     },

//     MuiAutocomplete: {
//       inputRoot: {
//         "&.MuiOutlinedInput-root": {
//           padding: "4px !important",
//         },
//       },
//     },

//     MuiFormControl: {
//       root: {
//         marginTop: "2px",
//         marginBottom: "2px",
//       },
//     },

//     MuiTabs: {
//       root: {
//         padding: "10px",
//         margin: "10px 10px 10px 1px",
//         minHeight: "auto",
//         display: "inline-flex",
//         borderRadius: 25,
//         backgroundColor: "#e0e0e0",
//       },
//       indicator: {
//         display: "none",
//       },
//     },
//     MuiTab: {
//       root: {
//         textTransform: "capitalize",
//         justifyContent: "center",   // center horizontally
//         textAlign: "center",        // ensure text itself is centered
//         minHeight: "auto",
//         minWidth: "auto !important",
//         padding: "6px 16px",        // ✅ equal padding left & right
//         borderRadius: 16,
//         marginRight: 8,
//         fontSize: 13,
//         fontWeight: 500,
//         color: "#444 !important",
//         backgroundColor: "transparent",
//         transition: "all 0.2s ease-in-out",
//         "&:hover": {
//           backgroundColor: "#f5f5f5",
//         },
//         "&$selected": {
//           backgroundColor: "#ffffff",
//           color: "#000 !important",
//           boxShadow: "0 1px 4px rgba(0, 0, 0, 0.1)",
//           fontWeight: 600,
//         },
//       },
//       selected: {},
//       wrapper: {
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center"
//       },
//     },
//     MuiButton: {
//       root: {
//         borderRadius: '20px',
//         textTransform: 'none',
//         fontWeight: 500,
//         minWidth: 'auto',
//         padding: '8px 20px !important',
//         fontSize: '0.85rem',
//         boxShadow: '0 1px 4px rgba(0, 0, 0, 0.1)',
//       },
//       // containedPrimary: {
//       //   backgroundColor: "#1c487a",
//       //   "&:hover": {
//       //     backgroundColor: "#122f53",
//       //   },
//       // },
//       containedSecondary: {
//         backgroundColor: "#f57c00",
//         "&:hover": {
//           backgroundColor: "#bb4d00",
//         },
//       },
//     },
//     MuiTableCell: {
//       root: {
//         padding: "8px 12px",
//         fontSize: 14,
//         color: "#333",
//       },
//       head: {
//         // fontWeight: 600,
//         // backgroundColor: "#f5f5f5",
//         // color: "#444",
//         whiteSpace: "nowrap",
//       },
//     },
//     MuiTableRow: {
//       root: {
//         "&:nth-of-type(odd)": {
//           backgroundColor: "#fafafa",
//         },
//         "&:hover": {
//           backgroundColor: "#f0f7ff",
//         },
//       },
//     },
//     MuiTableContainer: {
//       root: {
//         // borderRadius: 12,
//       },
//     },
//     MuiPopover: {
//       paper: {
//         borderRadius: 12,
//         boxShadow: "0px 4px 20px rgba(0,0,0,0.15)",
//         padding: "8px",
//       },
//     },
//   },
//   props: {
//     MuiPaper: {
//       elevation: 2,
//     },
//     MuiButton: {
//       disableElevation: true,
//     },
//     MuiCard: {
//       elevation: 0,
//     },
//     zIndex: {
//       drawer: 1200,
//       modal: 1300,
//       loader: 2000,
//     },
//   },

// });

// export default theme;

// theme.js (MUI v4)
import { createTheme } from "@material-ui/core/styles";

/**
 * Defines the complete theme configuration for both light and dark modes.
 * @param {'light' | 'dark'} type The palette type to generate the theme for.
 */
export const getTheme = (type = "light") => {
  const lightPalette = {
    type: "light",
    primary: { main: "#000000", light: "#333333", contrastText: "#ffffff" },
    secondary: { main: "#f57c00", light: "#ffad42", dark: "#bb4d00", contrastText: "#ffffff" },
    background: { default: "#f9f9f9", paper: "#ffffff", drawer: "#f5f6fa", main: "#ffffff", stickyEven: "#fafafa", stickyOdd: "#f0f0f0" },
    text: {
      primary: "#333",
      secondary: "#666",
      // night: "#4f46e5",
      // longDay: "#10b981",
      // notAvailable: "#ef4444",
      // earLy: "#f97316",
      // late: "#f7bc23",
      // twiLight: "#8b5cf6",
      night: "#4338ca",
      longDay: "#059669",
      notAvailable: "#dc2626",
      earLy: "#ea580c",
      late: "#ca8a04",
      twiLight: "#7c3aed",
    },
    thead: "#eceff4",
    listItem: "#515359",
    buttonMain: "#161a23",
    sidebar: "#eceff4",
    grey: {
      100: "#f5f5f5",
      200: "#eeeeee",
      300: "#e0e0e0",
      400: "#bdbdbd",
      500: "#9e9e9e",
      600: "#757575",
      700: "#616161",
      800: "#424242",
      900: "#212121",
      1000: "#f3f3f4",
    },
    frontWeight: {
      frontWeight100: 100,
      frontWeight200: 200,
      frontWeight300: 300,
      frontWeight400: 400,
      frontWeight500: 500,
      frontWeight600: 600,
      frontWeight700: 700,
      frontWeight800: 800,
      frontWeight900: 900,
    },
  };

  const darkPalette = {
    type: "dark",
    primary: { main: "#eee", light: "#cccccc", contrastText: "#000" },
    secondary: { main: "#ff9800", light: "#ffad42", dark: "#c77700", contrastText: "#000" },
    background: { default: "#121212", paper: "#535A51", drawer: "#131e2b", main: "#303640", stickyOdd: "#383737", stickyEven: "#252525" },
    text: {
      primary: "#fff",
      secondary: "#020000",
      night: "#6366f1",
      longDay: "#34d399",
      notAvailable: "#ef4444",
      earLy: "#fb923c",
      late: "#facc15",
      twiLight: "#a78bfa",
    },
    listItem: "#b6b7b9",
    buttonMain: "#f3f5f9",
    thead: "#2a2f33",
    sidebar: "#494e55",
    grey: {
      100: "#1e1e1e",
      200: "#2c2c2c",
      300: "#424242",
      400: "#616161",
      500: "#757575",
      600: "#9e9e9e",
      700: "#bdbdbd",
      800: "#e0e0e0",
      900: "#f5f5f5",
      1000: "#303640",
    },
    frontWeight: lightPalette.frontWeight,
  };

  const palette = type === "dark" ? darkPalette : lightPalette;

  // Ensure both `type` (v4) and `mode` (v5) are available for compatibility
  // Some components or style overrides may check `theme.palette.mode` while
  // older code uses `theme.palette.type`. Mirror the value to avoid issues.
  palette.mode = palette.type;

  // Chart colors can remain the same or adapt slightly if needed
  const chart = {
    primary: palette.primary.main,
    secondary: palette.secondary.main,
    success: "#4caf50",
    info: "#2196f3",
    warning: "#ff9800",
    error: "#f44336",
    lightGrey: type === "light" ? "#e0e0e0" : "#424242",
    darkGrey: type === "light" ? "#616161" : "#bdbdbd",
    palette: [
      palette.primary.main,
      palette.secondary.main,
      "#4caf50",
      "#2196f3",
      "#ff9800",
      "#f44336",
      "#616161",
      "#9e9e9e",
    ],
  };

  return createTheme({
    palette,
    chart,
    shape: { borderRadius: 16 },
    spacing: 8,
    typography: {
      fontFamily: "Aptos",
      fontSize: 14,
      h5: { fontWeight: 600, fontSize: "1.5rem" },
      h6: { fontWeight: 500, fontSize: "1.1rem" },
      body2: { color: palette.text.secondary, fontSize: "0.85rem", fontWeight: 500, marginBottom: "4px" },
      button: { textTransform: "none", fontWeight: 600 },
    },
    overrides: {
      // keep all existing overrides, just adjust colors for dark mode    
      MuiPaper: {
        root: {
          boxShadow: type === "light" ? "0 4px 20px 0 rgba(0,0,0,0.05)" : "0 4px 20px 0 rgba(0,0,0,0.3)",
          backgroundColor: palette.background.paper,
          color: palette.text.primary,
        },
      },
      MuiGrid: {
        container: { width: "100% !important", margin: "0 !important" },
      },
      MuiInputBase: {
        root: {
          backgroundColor: type === "light" ? "#ffffff" : "#494e55",
          color: palette.listItem,
          transition: "all 0.3s ease",
          "&$disabled": {
            backgroundColor: type === "light" ? "#f0f0f0" : "#212121",
          },
        },
      },
      MuiOutlinedInput: {
        root: {
          borderRadius: 6,
          // "&:hover fieldset": { borderColor: type === "light" ? "#999" : "#ccc" },
          "&.Mui-focused fieldset": {
            borderColor: palette.primary.main,
            boxShadow: `0 0 0 2px rgba(${type === "light" ? "0,0,0,0.08" : "255,255,255,0.1"})`,
          },
          "&.Mui-error fieldset": {
            borderColor: "red",
            boxShadow: "0 0 0 0.2rem rgba(244,67,54,0.25)",
          },
        },
        input: { padding: "12px", fontSize: 16, color: palette.listItem },
        notchedOutline: { borderColor: palette.listItem },
      },
      MuiFormLabel: {
        root: { fontSize: 16, fontWeight: 500, color: palette.listItem },
        focused: { color: palette.listItem },
      },
      MuiInputLabel: {
        outlined: { fontSize: 16, fontWeight: 500, transform: "translate(14px, 14px) scale(1)", '&.Mui-error': { color: "red" } },
      },
      MuiFormHelperText: {
        root: { fontSize: 12, marginLeft: "0px !important", marginRight: "0px !important", '&.Mui-error': { color: "red" } },
      },
      MuiAutocomplete: { inputRoot: { "&.MuiOutlinedInput-root": { padding: "4px !important" } } },
      MuiFormControl: { root: { marginTop: "2px", marginBottom: "2px" } },
      MuiTabs: {
        root:
        {
          padding: "10px", margin: "10px 10px 10px 1px", minHeight: "auto", display: "inline-flex", borderRadius: 25, backgroundColor: type === "light" ? "#e0e0e0" : "#2c2c2c"
        },
        indicator: { display: "none" }
      },
      MuiTab: {
        root: {
          textTransform: "none",
          justifyContent: "center",
          textAlign: "center",
          minHeight: "auto",
          minWidth: "auto !important",
          padding: "6px 16px",
          borderRadius: 16,
          marginRight: 8,
          fontSize: 13,
          fontWeight: 500,
          color: type === "light" ? "#444 !important" : "#ccc !important",
          backgroundColor: "transparent",
          transition: "all 0.2s ease-in-out",
          "&:hover": { backgroundColor: type === "light" ? "#f5f5f5" : "#333" },
          "&$selected": {
            backgroundColor: type === "light" ? "#ffffff" : palette.background.paper,
            color: type === "light" ? "#000 !important" : "#fff !important",
            boxShadow: type === "light" ? "0 1px 4px rgba(0, 0, 0, 0.1)" : "0 1px 4px rgba(255,255,255,0.1)",
            fontWeight: 600,
          },
        },
        selected: {},
        wrapper: { display: "flex", alignItems: "center", justifyContent: "center" },
      },
      MuiButton: {
        root: {
          borderRadius: "20px",
          textTransform: "none",
          fontWeight: 500,
          minWidth: "auto",
          padding: "8px 20px !important",
          fontSize: "0.85rem",
          boxShadow: type === "light" ? "0 1px 4px rgba(0,0,0,0.1)" : "0 1px 4px rgba(255,255,255,0.1)",
        },
        containedSecondary: {
          backgroundColor: palette.secondary.main,
          "&:hover": { backgroundColor: palette.secondary.dark },
        },
      },
      // overrides: {
      //   MuiTab: {
      //     root: {
      //       color: type === "light" ? "#515359" : "#b6b7b9"
      //     }
      //   }
      // },
      MuiTableCell: {
        root: { padding: "8px 12px", fontSize: 14, color: palette.text.primary },
        head: { whiteSpace: "nowrap" },
      },
      MuiTableRow: {
        root: {
          "&:nth-of-type(odd)": { backgroundColor: type === "light" ? "#fafafa" : "#494e55" },
          // "&:hover": { backgroundColor: type === "light" ? "#f0f7ff" : "#2a2a2a" },
        },
      },
      MuiTableContainer: { root: {} },
      MuiPopover: { paper: { borderRadius: 12, boxShadow: "0px 4px 20px rgba(0,0,0,0.15)", padding: "8px" } },
    },
    props: {
      MuiPaper: { elevation: 2 },
      MuiButton: { disableElevation: true },
      MuiCard: { elevation: 0 },
      zIndex: { drawer: 1200, modal: 1300, loader: 2000 },
    },
    styleOverrides: {
      body: {
        fontFamily: "Roboto, sans-serif",
        WebkitFontSmoothing: "antialiased",
        fontSize: "50px",
        MozOsxFontSmoothing: "grayscale",
        backgroundColor: palette.mode === "light" ? "#f4f4f59d !important" : "#121212 !important",
        color: "#18264d",
        height: "100%",
      },
    },
  });
};

// Export default light theme
export default getTheme("light");
